import axios from 'axios';
import Endpoint from './endpoint';
import { has, get } from 'lodash';
import ApiModule from './api-module';

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

class RESTApiService {
  endpoints = {};

  requestInterceptors = {};

  responseInterceptors = {};

  requestInterceptor = (name) => (request) => {
    Object.values(this.requestInterceptors).map((interceptor: any) => {
      interceptor(request, name);
    });

    request.serviceName = name;

    return request;
  };

  responseInterceptor = (name) => (response) => {
    Object.values(this.responseInterceptors).map((interceptor: any) => {
      interceptor(response, name);
    });

    response.serviceName = name;

    return response;
  };

  setResponseInterceptor = (name, interceptor) => {
    this.responseInterceptors[name] = interceptor;
  };

  setRequestInterceptor = (name, interceptor) => {
    this.requestInterceptors[name] = interceptor;
  };

  removeRequestInterceptor = (name) => {
    if (this.requestInterceptors[name]) {
      delete this.requestInterceptors[name];
    }
  };

  removeResponseInterceptor = (name) => {
    if (this.responseInterceptors[name]) {
      delete this.responseInterceptors[name];
    }
  };

  getEndpoint = (key): any => {
    if (has(this.endpoints, key)) {
      return get(this.endpoints, key);
    }

    throw new Error(`Endpoint with path ${key} does not exists.`);
  };

  registerEndpoints = (...endpoints) => {
    endpoints.forEach((endpoint) => this.registerEndpoint(endpoint));
  };

  registerEndpoint = ({ name, url, ...rest }: any): Endpoint => {
    this.endpoints[name] = new Endpoint({ name, url, ...rest });
    const { endpoint } = this.endpoints[name] || {};

    endpoint.interceptors.response.use(this.responseInterceptor(name));
    endpoint.interceptors.request.use(this.requestInterceptor(name));

    return this.endpoints[name];
  };

  getResource = (path): ApiModule => {
    const [endpointName, resourceName] = path.split('.');
    try {
      if (resourceName) {
        return this.getEndpoint(endpointName).getResource(resourceName);
      }

      return this.getEndpoint(endpointName);
    } catch (error) {
      throw new Error(
        `Rest api service call failed path ${path} to resource is incorrect.`,
      );
    }
  };
}

export default new RESTApiService();
